import React, { useEffect, useReducer } from 'react'
import { useRouteMatch } from 'react-router-dom'
import PropTypes from 'prop-types'

import data from '../data'

const Context = React.createContext()

const defaultLang = 'en'

// Convert data to array
const allData = Object.values(data).map(value => value)

function appReducer(state, action) {
  switch (action.type) {
    case 'setActiveNav':
      return {
        ...state,
        activeNav: action.payload
      }
    case 'switchLang':
      return {
        ...state,
        lang: action.payload
      }
    case 'switchLayer':
      return {
        ...state,
        activeLayer: action.payload
      }
    case 'updateActiveProject':
      return {
        ...state,
        activeProject: action.payload
      }
    case 'setActiveChart':
      return {
        ...state,
        activeChart: action.payload
      }
    default:
      return state
  }
}

export function StoreProvider({ children }) {
  const match = useRouteMatch('/map/:layer')
  const activeLayer = (match && match.params && match.params.layer) || 'surface'
  const defaultActiveChart = 'abstraction'
  const initalState = {
    data: allData,
    lang: defaultLang,
    activeLayer: activeLayer,
    activeProject: null,
    activeNav: null,
    activeChart: defaultActiveChart
  }

  const [state, dispatch] = useReducer(appReducer, initalState)

  // Update active layer when url changes and reset active project
  useEffect(() => {
    dispatch({ type: 'switchLayer', payload: activeLayer || 'surface' })
    dispatch({ type: 'updateActiveProject', payload: null })
  }, [activeLayer])

  return (
    <Context.Provider value={{ state, dispatch }}>{children}</Context.Provider>
  )
}

StoreProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
}

function useStore() {
  const { state, dispatch } = React.useContext(Context)

  return {
    state,
    dispatch
  }
}

export default useStore
